var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 266,
    viewBox: "0 0 272 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7638 58.1786C28.5207 57.8376 11.5058 45.8351 11.7104 31.3776C11.9491 16.92 29.3391 5.46307 50.5821 5.76996C71.8252 6.07684 88.8401 18.1134 88.6355 32.571C88.3968 47.0627 71.0068 58.5196 49.7638 58.1786Z",
    fill: "url(#paint0_linear_14_3611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8127 25.615L11.7104 31.3776C11.9491 16.92 29.3391 5.46309 50.5821 5.76997C71.8252 6.07685 88.8401 18.1135 88.6355 32.571L88.7378 26.8084C88.9765 12.3509 71.9275 0.348377 50.6844 0.00739664C29.4414 -0.333584 12.0173 11.1574 11.8127 25.615Z",
    fill: "url(#paint1_linear_14_3611)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7978 56.5078C30.6688 56.2009 15.3588 45.4259 15.5634 32.4004C15.768 19.375 31.419 9.07742 50.5479 9.35021C69.6769 9.65709 84.987 20.432 84.7824 33.4575C84.5437 46.517 68.8927 56.8147 49.7978 56.5078Z",
    fill: "url(#paint2_linear_14_3611)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7978 55.5531C30.9075 55.2463 15.7339 44.7099 15.5634 31.9232C15.5634 32.0937 15.5293 32.2301 15.5293 32.4006C15.3247 45.426 30.6688 56.2351 49.7637 56.5079C68.8927 56.8148 84.5437 46.483 84.7483 33.4576C84.7483 33.2871 84.7483 33.1507 84.7483 32.9802C84.1686 45.8011 68.6881 55.86 49.7978 55.5531Z",
    fill: "#A86314"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9298 150.584C20.985 170.293 10.9602 184.819 6.52741 183.012C2.09467 181.238 4.9248 163.814 12.8696 144.106C20.8145 124.397 30.8393 109.871 35.272 111.678C39.7048 113.486 36.8746 130.91 28.9298 150.584Z",
    fill: "url(#paint3_linear_14_3611)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5888 150.448C21.4624 168.179 12.4264 181.238 8.43692 179.636C4.44745 178.033 7.00481 162.348 14.1313 144.617C21.2578 126.886 30.2938 113.827 34.2832 115.429C38.2727 117.032 35.7153 132.717 28.5888 150.448Z",
    fill: "url(#paint4_linear_14_3611)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1456 150.277C21.1555 167.667 12.3241 180.591 8.23236 179.534C8.30056 179.568 8.36874 179.602 8.43694 179.636C12.4264 181.238 21.4624 168.179 28.5889 150.448C35.7154 132.717 38.2727 117.032 34.2832 115.429C34.215 115.395 34.1128 115.395 34.0446 115.361C37.7271 117.475 35.1357 132.887 28.1456 150.277Z",
    fill: "#A86314"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09467 181.238L6.5615 183.046C2.12876 181.273 4.9589 163.848 12.9037 144.14C20.8486 124.431 30.8734 109.905 35.3061 111.712L30.8393 109.905C26.4066 108.132 16.3817 122.658 8.43689 142.333C0.492056 162.041 -2.33807 179.465 2.09467 181.238Z",
    fill: "url(#paint5_linear_14_3611)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.165 40.0044C210.433 35.4353 194.442 27.9679 195.464 23.2964C196.487 18.625 214.15 18.5568 234.882 23.1259C255.613 27.6951 271.605 35.1626 270.582 39.834C269.559 44.4713 251.897 44.5736 231.165 40.0044Z",
    fill: "url(#paint6_linear_14_3611)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.233 39.6294C212.582 35.5376 198.192 28.7862 199.113 24.5922C200.034 20.3981 215.923 20.3299 234.575 24.4217C253.226 28.5134 267.616 35.2649 266.695 39.4589C265.809 43.653 249.919 43.7211 231.233 39.6294Z",
    fill: "url(#paint7_linear_14_3611)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.336 39.152C213.025 35.1284 198.84 28.5475 199.181 24.3534C199.147 24.4216 199.113 24.4899 199.113 24.5922C198.192 28.7862 212.582 35.5376 231.233 39.6293C249.885 43.7211 265.775 43.6529 266.695 39.4589C266.729 39.3907 266.729 39.2884 266.729 39.2202C265.297 43.1755 249.68 43.1755 231.336 39.152Z",
    fill: "#A86314"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196.487 18.5909L195.464 23.2964C196.487 18.625 214.15 18.5568 234.882 23.1259C255.613 27.695 271.605 35.1625 270.582 39.834L271.605 35.1284C272.628 30.457 256.636 22.9896 235.905 18.4204C215.173 13.8513 197.544 13.9194 196.487 18.5909Z",
    fill: "url(#paint8_linear_14_3611)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.56 208.108C118.915 226.043 115.88 248.343 100.774 257.925C85.669 267.472 64.2213 260.687 52.8667 242.717C41.5121 224.782 44.5468 202.481 59.6522 192.9C74.7576 183.352 96.2053 190.172 107.56 208.108Z",
    fill: "url(#paint9_linear_14_3611)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.798 209.847C115.027 226.009 112.265 246.059 98.6944 254.685C85.0893 263.278 65.7898 257.175 55.5604 241.012C45.331 224.85 48.0929 204.8 61.6639 196.173C75.3031 187.581 94.6026 193.684 104.798 209.847Z",
    fill: "url(#paint10_linear_14_3611)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8643 260.994L100.74 257.925C85.6349 267.472 64.1872 260.687 52.8326 242.717C41.4779 224.782 44.5126 202.481 59.6181 192.9L54.742 195.969C39.6366 205.516 36.6019 227.816 47.9565 245.786C59.3112 263.756 80.7588 270.575 95.8643 260.994Z",
    fill: "url(#paint11_linear_14_3611)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.014 210.358C114.141 226.35 111.549 246.161 98.2852 254.924C98.4216 254.856 98.558 254.754 98.6944 254.685C112.3 246.093 115.027 226.009 104.798 209.847C94.5685 193.684 75.269 187.581 61.6639 196.173C61.5275 196.276 61.3912 196.344 61.2548 196.446C74.8599 188.228 93.8866 194.366 104.014 210.358Z",
    fill: "#7E470D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M154.547 73.5567C133.713 69.4991 116.05 70.0105 115.13 74.716C114.209 79.4216 130.372 86.4799 151.24 90.5375C172.073 94.5952 189.736 94.0496 190.657 89.3782C191.577 84.6727 175.415 77.5803 154.547 73.5567Z",
    fill: "url(#paint12_linear_14_3611)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M154.479 73.9318C135.725 70.2834 119.835 70.7607 119.017 74.9889C118.199 79.217 132.758 85.5933 151.512 89.2418C170.266 92.8903 186.156 92.4129 186.974 88.1848C187.793 83.9225 173.233 77.5462 154.479 73.9318Z",
    fill: "url(#paint13_linear_14_3611)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.377 74.3751C135.964 70.7948 120.347 71.1699 118.983 75.1935C118.983 75.1253 118.983 75.0229 119.017 74.9547C119.835 70.7266 135.725 70.2492 154.479 73.8977C173.233 77.5462 187.793 83.9226 186.974 88.1507C186.974 88.2189 186.94 88.3212 186.906 88.3894C187.145 84.1612 172.789 77.9554 154.377 74.3751Z",
    fill: "#7E470D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.243 79.4217L115.164 74.7161C114.243 79.4217 130.406 86.4799 151.274 90.5376C172.107 94.5953 189.77 94.0497 190.691 89.3783L189.77 94.0838C188.85 98.7893 171.221 99.3008 150.353 95.2431C129.485 91.1855 113.322 84.1272 114.243 79.4217Z",
    fill: "url(#paint14_linear_14_3611)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_3611",
    x1: 50.5888,
    y1: 5.02081,
    x2: 49.693,
    y2: 62.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_3611",
    x1: 8.12044,
    y1: 15.3387,
    x2: 78.7038,
    y2: 16.4399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_3611",
    x1: 52.0941,
    y1: -63.0559,
    x2: 49.2888,
    y2: 75.6808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_3611",
    x1: 12.6521,
    y1: 144.037,
    x2: 30.2459,
    y2: 151.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_3611",
    x1: -17.6599,
    y1: 131.832,
    x2: 38.3155,
    y2: 154.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0459,
    stopColor: "#FFDF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7A22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14_3611",
    x1: -0.43596,
    y1: 182.367,
    x2: 30.7905,
    y2: 104.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14_3611",
    x1: 234.939,
    y1: 22.8514,
    x2: 230.863,
    y2: 41.3746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14_3611",
    x1: 237.98,
    y1: 13.4321,
    x2: 230.27,
    y2: 41.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14_3611",
    x1: 194.971,
    y1: 16.2848,
    x2: 276.621,
    y2: 34.2516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2011,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6514,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14_3611",
    x1: 92.2459,
    y1: 217.8,
    x2: 56.7876,
    y2: 240.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14_3611",
    x1: 31.0379,
    y1: 256.519,
    x2: 103.869,
    y2: 210.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_14_3611",
    x1: 85.6373,
    y1: 269.696,
    x2: 45.2554,
    y2: 205.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_14_3611",
    x1: 150.046,
    y1: 94.1237,
    x2: 157.385,
    y2: 63.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_14_3611",
    x1: 160.524,
    y1: 42.7963,
    x2: 150.189,
    y2: 96.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14_3611",
    x1: 111.917,
    y1: 80.9274,
    x2: 193.985,
    y2: 96.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE7A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1216,
    stopColor: "#E9A83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2191,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2776,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3693,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3821,
    stopColor: "#E6B248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3992,
    stopColor: "#CB9235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#B57925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4354,
    stopColor: "#A6681B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4552,
    stopColor: "#9D5D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4784,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#9F5F15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6015,
    stopColor: "#AD6D1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#C48429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7451,
    stopColor: "#E4A43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7956,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C5110"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin1);
export default __webpack_public_path__ + "static/media/coin1.d1d84e11528857580b57395d3376f869.svg";
export { ForwardRef as ReactComponent };